<template>
  <div>
    <i-circle :percent="100" stroke-color="#5cb85c" v-if="success">
      <Icon type="ios-checkmark" size="60" style="color:#5cb85c"></Icon>
    </i-circle>
    <i-circle :percent="100" stroke-color="#ff5500" v-if="fail">
      <span class="demo-Circle-inner">
        <Icon type="ios-close" size="50" style="color:#ff5500"></Icon>
      </span>
    </i-circle>
    <p style="font-weight:800;font-size:20px;margin-top:10px" v-html="msg"></p>
    <Button type="primary" style="margin-top:20px" @click="callBack">返回</Button>
  </div>
</template>
<script>
export default {
  props: {
    result: {},
    msg: {},
    onOk: {
      type: Function
    }
  },
  mounted() {
  	console.log(this.result);
    this.changeStatus(this.result);
  },
  data() {
    return {
      success: true,
      fail: false
    };
  },
  methods: {
    callBack() {
      this.onOk();
    },
    changeStatus(result) {
      this.success = false;
      this.fail = false;

      if (result == "success") {
        this.success = true;
      } else {
        this.fail = true;
      }
    }
  }
};
</script>
